import { TrendingUp } from '@mui/icons-material'

import { TopSourcesChart } from '@/components/charts/TopSourcesChart'

import { DimensionReport } from './DimensionReport'

export function SourcesPage() {
    return (
        <DimensionReport
            title="Traffic Sources"
            subtitle="Where sessions come from — channels are classified at ingest."
            emptyIcon={<TrendingUp />}
            emptyTitle="No source data yet"
            emptyDescription="Traffic source data will appear once visitors start arriving."
            tabs={[
                {
                    dim: 'channel',
                    label: 'Channel',
                    chart: rows => (
                        <TopSourcesChart
                            sources={rows.map(r => ({ source: r.key, visitors: r.visitors }))}
                        />
                    ),
                },
                { dim: 'referrer', label: 'Referrer' },
                { dim: 'utm_source', label: 'UTM source' },
                { dim: 'utm_campaign', label: 'UTM campaign' },
                { dim: 'host', label: 'Host' },
                // Presence only: which ad click-id types landed sessions carried, never the value.
                { dim: 'click_id', label: 'Click id present' },
            ]}
        />
    )
}
